import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { QRCodeModule } from 'angular2-qrcode';
import { HttpModule } from '@angular/http';
//Router
import { APP_ROUTING } from './app.routes';

//lenguaje
import { LOCALE_ID } from '@angular/core'

//map
import { AgmCoreModule } from '@agm/core';

//gallery and slider
import { NgxGalleryModule } from 'ngx-gallery';

import { QuillEditorModule } from 'ng2-quill-editor';

import { MyDatePickerModule } from 'mydatepicker';

//PAGES
import { AppComponent } from './app.component';
import {
  HomeComponent, FooterComponent, NavbarComponent, PerfilComponent,
  AdministrarblogComponent,AdministraCategoriasComponent,AdministraProductosComponent,
  AdministraMarcasComponent,ReporteVentasComponent,AdministraImgProductoComponent,
  AdministraImgMcComponent

} from './index.paginas';

//Services
import { ConsultaService } from './services/consulta.service';
import { CompraService } from './services/compra.service';
import { AdministraMarcasService } from './services/administra-marcas.service';
import { CategoriasService } from './services/categorias.service';
import { ProductosService } from './services/productos.service';
import { ResportesAdminService } from './services/resportes-admin.service';

import { UploadFileComponent } from './components/upload-file/upload-file.component';
import { InputTrimModule } from 'ng2-trim-directive';


@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    FooterComponent,
    HomeComponent,
    PerfilComponent,
    AdministrarblogComponent,
    UploadFileComponent,
    AdministraCategoriasComponent,
    AdministraProductosComponent,
    AdministraMarcasComponent,
    ReporteVentasComponent,
    AdministraImgProductoComponent,
    AdministraImgMcComponent
  ],
  imports: [
    BrowserModule,
    APP_ROUTING,
    FormsModule,
    ReactiveFormsModule,
    QRCodeModule,
    HttpModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyCG4IZkfcxN7UxjhSo55FX5umP5D63L2GM'
    }),
    NgxGalleryModule,
    QuillEditorModule,
    MyDatePickerModule,
    InputTrimModule
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'esMX' },
    ConsultaService,
    CompraService,
    CategoriasService,
    ProductosService,
    AdministraMarcasService,
    ResportesAdminService

  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// C:/Users/EZepeda/Desktop/Explora/adminexplora/src/app/app.module.ts